import { useTranslations } from "next-intl";
import { useCurrentUser, useSubscriptionEligibleTo } from "@hooks/use-current-user";
import { useBalReturnAvailableFor } from "@hooks/use-addresses";
import { useFormatDate } from "@hooks/use-format-date";
import { Button, Link } from "@components/core";
import carriers from "@utils/constants/carriers";
import { getReturnLink } from "@utils/getReturnLink";

function ClosetActionReceived({ closet }) {
  const tClosets = useTranslations("closets");
  const tCommon = useTranslations("common");

  const user = useCurrentUser();
  const formatDate = useFormatDate();

  const subscriptionEligibleTo = useSubscriptionEligibleTo();
  const nextInvoiceDate = user.next_invoice_date;

  const balReturnAvailableForCountry = useBalReturnAvailableFor(closet?.return_country);

  const closetReturnCarrierName = closet?.return_carrier_name;
  const closetReturnCountry = closet?.return_country.toLowerCase();
  const balReturnAvailable =
    closetReturnCarrierName === carriers.colissimo && balReturnAvailableForCountry;

  const subtitle = () => {
    switch (subscriptionEligibleTo) {
      case "next_closet":
        return (
          <p className="mb-0">{tClosets("state.received.closet_action_text.return_closet")}</p>
        );
      case "no_next_closet_no_unlock_early":
        return (
          <p className="mb-0">
            {tClosets(
              "state.received.closet_action_text.you_will_be_able_to_enjoy_your_next_closet_from",
              { date: formatDate(nextInvoiceDate) },
            )}
          </p>
        );
      default:
        return null;
    }
  };

  const displayBalRequestAvailableButtons = () => {
    return (
      <div className="d-flex mb-3 flex-column align-items-md-center">
        <Link
          href={`/carriers/closet_return?closet_id=${closet?.id}`}
          className="w-100"
        >
          <Button
            className="mb-3"
            fullWidth
          >
            {tClosets("state.received.closet_action_button_title.request_mailbox_collection")}
          </Button>
        </Link>
        <Link
          noUnderline
          href="/carriers/relay_points/colissimo"
          className="text-center link-primary w-100"
        >
          <Button
            variant="outline-primary"
            fullWidth
          >
            {tClosets("state.received.closet_action_button_title.find_a_relay_point")}
          </Button>
        </Link>
      </div>
    );
  };

  const goToRelayPointPage = () => {
    const linkUrl = getReturnLink(closetReturnCarrierName, closetReturnCountry);

    return (
      <a
        href={linkUrl}
        target={linkUrl.startsWith("http") ? "_blank" : "_self"}
        rel="noopener noreferrer"
      >
        <Button className="mx-auto mb-3">
          {tClosets("state.received.closet_action_button_title.find_a_relay_point")}
        </Button>
      </a>
    );
  };

  return (
    <div>
      <div className="mb-3">
        {subtitle()}
        {closet.mail_box_picking_date_requested_at && (
          <p className="mb-0">
            {tCommon("drawer.modal_closet_received.mail_box_picking_request_done")}
          </p>
        )}
      </div>
      <div className="d-sm-flex flex-column align-items-start">
        {balReturnAvailable ? displayBalRequestAvailableButtons() : goToRelayPointPage()}
      </div>
    </div>
  );
}

export default ClosetActionReceived;
